import React from 'react';
import PropTypes from 'prop-types';
import {RenderRoutes} from 'base/routes';
import {BrowserRouter as Router} from 'react-router-dom';
import {Provider} from 'react-redux';
import {ReduxAsyncConnect} from 'redux-connect';

const Root = ({store, routes}) => (
  <Provider store={store}>
    <Router>
      <ReduxAsyncConnect routes={routes}/>
    </Router>
  </Provider>
);

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  routes: PropTypes.array.isRequired
};

export default Root;



// WEBPACK FOOTER //
// ./routes/Root.jsx